'use strict';

var deployment = process.env.DEPLOYMENT || 'preprod';
var baseUrl = deployment === 'prod' || deployment === 'pc' ? 'https://www.liveauctioneers.com' : 'https://' + deployment + '-test.liveauctioneers.com';
var classicBaseUrl = deployment === 'prod' || deployment === 'pc' ? 'https://classic.liveauctioneers.com' : 'https://mainhost-' + deployment + '.liveauctioneers.com';
var segmentWriteKey = deployment === 'prod' || deployment === 'pc' ? 'HoHgffZL05YMRQr7OAzt1zyzp9ySNQnq' : '2VVBXTAj8OAmELKqpJhQBVy8wxquVSE5';
var buildNumber = process.env.BUILD;
var cachekey = 20170802; // change to break cache.
var pubNubSubscribeKey = deployment === 'prod' || deployment === 'pc' || deployment === 'preprod' ? 'sub-c-afcdf614-eb2a-11e7-acf8-26f7716e5467' : 'sub-c-3bc9bd46-1c28-11e8-bb29-5a43d096f02f';
var stripePublishKey = deployment === 'prod' || deployment === 'pc' || deployment === 'preprod' ? 'pk_live_IQCt8ISLv0ih1YlxIWoMbiCs' : 'pk_test_h4oTIGGE4a5mKDPRz8H0gkFT';

var baseCuratorImgUrl = 'https://s3.amazonaws.com/images.liveauctioneers.com/curators';
var curatorImgUrl = deployment === 'prod' || deployment === 'pc' || deployment === 'preprod' ? baseCuratorImgUrl : baseCuratorImgUrl + '/stage';

var referralCandy = {
    houseIdForReferrals: 5584,
    id: 'gxctnclfwvd0gv4bazqhums4c',
    secret: '791390824dbf598938847ebaf55cf85c'
};

module.exports = {
    auctionHouseSize: 3,
    baseUrl: baseUrl,
    buildNumber: buildNumber,
    cachekey: cachekey,
    classicBaseUrl: classicBaseUrl,
    curatorImgUrl: curatorImgUrl,
    deployment: deployment,
    giveRawResults: true,
    googleApiKey: 'AIzaSyAmAThAjRtRsBG8quyWUuHk7XH_GNbcoRk',
    host: process.env.HOST || 'localhost',
    port: process.env.PORT || 3000,
    pubNubSubscribeKey: pubNubSubscribeKey,
    querySize: 6,
    referralCandy: referralCandy,
    sailthruCustomerId: '3ae424afe5d152e7a420ba8614f4ba16',
    segmentWriteKey: segmentWriteKey,
    soastaMPulseApiKey: 'P4TR8-DZB39-665FZ-Q5A4W-7K7EB',
    stripePublishKey: stripePublishKey
};


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = QmSG
// module chunks = 60